(() => {
  "use strict";
  const t = {},
    e = {
      filterButton: "data-show-filters",
      filters: "data-filter-box",
      closeFilters: "data-close-filters",
      filterContent: "data-filter-content",
    },
    r = () => {
      (t.filterButton = document.querySelector(`[${e.filterButton}]`) || !1),
        (t.filters = document.querySelector(`[${e.filters}]`) || !1),
        (t.closeFilters = [
          ...document.querySelectorAll(`[${e.closeFilters}]`),
        ]),
        t.filterButton &&
          t.filterButton.addEventListener("click", () => {
            t.filters && t.filters.classList.toggle("open"),
              t.filters.classList.contains("open")
                ? (document.body.classList.add("overflow-hidden"),
                  (document.querySelector(
                    `[${e.filterContent}]`
                  ).scrollTop = 0))
                : document.body.classList.remove("overflow-hidden");
          }),
        t.closeFilters &&
          t.closeFilters.forEach((e) => {
            e.addEventListener("click", () => {
              t.filters.classList.remove("open"),
                document.body.classList.remove("overflow-hidden");
            });
          });
    },
    a = () =>
      new Proxy(new URLSearchParams(window.location.search), {
        get: (e, t) => e.get(t),
      }),
    c = (t, r = 300) => {
      let l = null;
      return (...e) => {
        clearTimeout(l),
          (l = setTimeout(() => {
            t.apply(void 0, e);
          }, r));
      };
    },
    n = {},
    s = {
      productWrapper: "data-products-wrapper",
      grid: "data-collection-grid",
      loadMore: "data-load-next-page",
      minPrice: "data-min-price",
      maxPrice: "data-max-price",
      rangeBackground: "data-range-background",
      collectionInfo: "data-collection-count",
      currentCount: "data-current-product-count",
      collectionTotal: "data-collection-total",
      filterSummary: "data-filter-summary",
      filterList: "data-filter-short-list",
    },
    d = {
      filterInputs: "data-filter-input",
      clearAllFilters: "data-clear-filters",
    },
    u = { filters: [], page: 1, fetchTimestamp: 0, pageSize: 12 },
    m =
      ((window.setFilter = (e) => {
        var t;
        u.filters.includes(e)
          ? ((t = u.filters.indexOf(e)), u.filters.splice(t, 1))
          : u.filters.push(e),
          m();
      }),
      (r = !1, l = !0) => {
        !1 === r &&
          (n.productWrapper.classList.add("opacity-0"),
          (u.fetchTimestamp = Date.now()),
          (u.page = 1));
        const i = u.filters.join("&"),
          o = window.state.sortBy ? `sort_by=${window.state.sortBy}&` : "";
        var e = window.eHS.search
          ? `/search/?q=${window.eHS.search}&view=page`
          : `/collections/${window.eHS.collectionHandle}?view=page&${o}page=${u.page}&` +
            i;
        return fetch(e)
          .then((e) => e.text())
          .then((e) => {
            !0 !== l ||
              window.eHS.search ||
              ((t = 1 < u.page ? `pageOn=${u.page}&` : ""),
              history.replaceState(
                {},
                "title",
                `/collections/${window.eHS.collectionHandle}?` + o + t + i
              )),
              !0 === r ? (n.grid.innerHTML += e) : (n.grid.innerHTML = e),
              window.setupProductTiles();
            var t = Date.now() - u.fetchTimestamp;
            f(),
              setTimeout(() => {
                n.productWrapper.classList.remove("opacity-0");
              }, 1e3 - t),
              new Yotpo.API(yotpo).refreshWidgets(),
              callback && callback();
          });
      }),
    f = () => {
      const e = document.querySelector(`[${s.collectionInfo}]`);
      var t = parseInt(e.getAttribute(s.collectionInfo), 10),
        r = u.page * u.pageSize;
      n.currentCount &&
        (n.currentCount.innerHTML = Math.min(r, t) + " of " + t),
        n.collectionTotal && (n.collectionTotal.innerHTML = t),
        t <= r
          ? n.loadMore.classList.add("!hidden")
          : n.loadMore.classList.remove("!hidden"),
        p();
    },
    p = () => {
      0 < u.filters.length
        ? n.filterSummary && n.filterSummary.classList.remove("hidden")
        : n.filterSummary && n.filterSummary.classList.add("hidden"),
        n.filterList &&
          ((n.filterList.innerHTML = ""),
          u.filters.forEach((e) => {
            if (!e.includes("price")) {
              const t = document.querySelector(`[${d.filterInputs}="${e}"]`);
              n.filterList.innerHTML += `
        <div class="flex items-center justify-between txt">
          <span>
            ${t.getAttribute("data-full-label")}: <b>${t.getAttribute(
                "data-full-text"
              )}</b>
          </span>
          <label class="flex align-center cursor-pointer" for="${t.getAttribute(
            "id"
          )}" aria-label="Clear ${t.getAttribute(
                "data-full-label"
              )} ${t.getAttribute("data-full-text")}">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.01367 1.00684L8.99982 8.99298M1.01367 8.99298L8.99982 1.00684" stroke="#2E2E2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </label>
        </div>`;
            }
          }));
    },
    i = () =>
      !(!n.maxPrice || !n.minPrice) && {
        minValue: parseInt(n.minPrice.value, 10),
        maxValue: parseInt(n.maxPrice.value, 10),
        step: parseInt(n.minPrice.step, 10),
        rangeMax: parseInt(n.maxPrice.getAttribute("max"), 10),
      },
    g = () => {
      var e,
        t,
        r = i();
      !1 !== r &&
        (({ minValue: r, maxValue: t, step: e } = r),
        (r = (100 * r) / (20 * e)),
        (t = 100 - (100 * t) / (20 * e)),
        (n.rangeBackground.style.left = r + "%"),
        (n.rangeBackground.style.right = Math.max(t, 1) + "%"));
    },
    o = () => {
      var e,
        t,
        r = i();
      !1 !== r &&
        (({ minValue: r, maxValue: e, rangeMax: t } = r),
        (u.filters = u.filters.filter((e) => !e.includes("filter.v.price"))),
        0 < r && u.filters.push("filter.v.price.gte=" + r / 100),
        e < t && u.filters.push("filter.v.price.lte=" + e / 100));
    },
    h = (e) => {
      var { minValue: t, maxValue: r, step: l } = i();
      "max" === e && r <= t + l
        ? (n.maxPrice.value = t + l)
        : "min" === e && r <= t + l && (n.minPrice.value = r - l),
        g(),
        o();
    },
    v = () => {
      (u.page += 1),
        m(!0, !1).then(() => {
          u.page < a().pageOn && v();
        });
    },
    l = () => {
      var r, l, i, o;
      (r = n),
        (l = s),
        (i = d),
        (o = !0),
        Object.keys(l).forEach((e) => {
          var t = l[e];
          r[e] = document.querySelector(o ? `[${t}]` : t) || !1;
        }),
        Object.keys(i).forEach((e) => {
          var t = i[e];
          r[e] = [...document.querySelectorAll(o ? `[${t}]` : t)];
        }),
        g(),
        1 < a().pageOn && v(),
        n.filterInputs.forEach((e) => {
          !1 !== e.checked &&
            u.filters.push(e.getAttribute("name") + "=" + e.value);
        }),
        p(),
        n.clearAllFilters.forEach((e) => {
          e.addEventListener("click", () => {
            n.filterInputs.forEach((e) => (e.checked = !1)),
              n.minPrice &&
                n.maxPrice &&
                ((n.minPrice.value = 0),
                (n.maxPrice.value = n.maxPrice.getAttribute("max")),
                g()),
              (u.filters = []),
              m();
          });
        }),
        n.minPrice &&
          n.maxPrice &&
          (n.minPrice.addEventListener("input", () => h("min")),
          n.maxPrice.addEventListener("input", () => h("max")),
          n.minPrice.addEventListener(
            "change",
            c(() => m())
          ),
          n.maxPrice.addEventListener(
            "change",
            c(() => m())
          )),
        window.listenToState(() => {
          (u.page = 1), m();
        }, "sortBy"),
        n.loadMore.addEventListener("click", () => {
          (u.page += 1), m(!0);
        });
    },
    w = {},
    L = {
      collectionHero: "data-collection-hero",
      collectionFullDesc: "data-full-description",
      collectionDesc: "data-description",
      readMoreButton: "data-read-more",
    },
    y = () => {
      (w.collectionHero =
        document.querySelector(`[${L.collectionHero}]`) || !1),
        w.collectionHero &&
          (w.collectionFullDesc = w.collectionHero.querySelector(
            `[${L.collectionFullDesc}]`
          )),
        w.collectionHero &&
          (w.collectionDesc = w.collectionHero.querySelector(
            `[${L.collectionDesc}]`
          )),
        w.collectionHero &&
          (w.readMoreButton = w.collectionHero.querySelector(
            `[${L.readMoreButton}]`
          )),
        w.readMoreButton &&
          w.collectionFullDesc &&
          w.collectionDesc &&
          w.readMoreButton.addEventListener("click", (e) => {
            w.collectionFullDesc.classList.remove("hidden"),
              w.collectionDesc.classList.remove("block"),
              w.collectionDesc.classList.add("hidden");
          });
    };
  document.addEventListener("DOMContentLoaded", () => {
    r(), l(), y();
  });
})();
